import {
  type ActionLink,
  type CarReservationSelfServeLinksProps,
  CarSelfServeModalType,
} from "@apac/components/cars";
import { IconNameEnum } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Icon } from "@tenant/ui";
import { useCarTripStatus } from "@/modules/cars-postbooking/hooks";

export const useCarReservationSelfServeLinks = ({
  reservation,
  actionMap,
}: CarReservationSelfServeLinksProps) => {
  const { isPastOrCanceled } = useCarTripStatus(reservation.reservation);

  const { t } = useI18nContext();
  const getActions = () => {
    const actions: ActionLink[] = [];
    if (!isPastOrCanceled) {
      actions.push(
        {
          content: actionMap?.[CarSelfServeModalType.ResendEmail] ?? (
            <>
              <Icon iconName={IconNameEnum.email} />
              {t("trips.tripReviewLinks.resendEmail")}
            </>
          ),
          modalType: CarSelfServeModalType.ResendEmail,
        },
        {
          content: actionMap?.[CarSelfServeModalType.Cancel] ?? (
            <>
              <Icon iconName={IconNameEnum.cancelCircle} />
              {t("trips.tripReviewLinks.cancelRental")}
            </>
          ),
          modalType: CarSelfServeModalType.Cancel,
        }
      );
    }
    if (actionMap?.[CarSelfServeModalType.Invoice] !== null) {
      actions.push({
        content: actionMap?.[CarSelfServeModalType.Invoice],
        modalType: CarSelfServeModalType.Invoice,
      });
    }

    actions.push({
      content: actionMap?.[CarSelfServeModalType.ContactSupport] ?? (
        <>
          <Icon iconName={IconNameEnum.questionCircle} />
          {t("trips.tripReviewLinks.contactSupport")}
        </>
      ),
      modalType: CarSelfServeModalType.ContactSupport,
    });
    return actions;
  };
  return {
    actions: getActions(),
  };
};
